import React, { useState } from "react";
import ContainerEventsQuery from "../Components/ContainerEventsQuery";
import ImgProfileNewbieOver from "../medias/femme-cap_U1RVRElPIEtBVCA0MDYtMjk copier.jpg";
import checkboxesFormat from "../Data/TriathlonSizeData";
import Select from "react-select";
import Regions from "../Data/ListRegions";
import triDiscover from "../medias/1920-waikoloa-usa-2011-Goran Bogicevic.JPG";
import Group from "@material-ui/icons/Group";

export const Discover = () => {
  const [region, setSelectedRegion] = useState({
    value: "Ile-de-France",
    label: "Ile-de-France",
  });
  const handleRegion = (region) => {
    //en paramètre la valeur (selectedRegion) et non la fontion (setSelectedRegion)
    setSelectedRegion(region);
  };

  return (
    <section>
      {/* header */}
      <div className="container mt-5">
        <div className="pt-3 visible-sm"></div>
        <h1 className="text-warning">Débuter et découvrir le triathlon</h1>
        <br />
        <div className="row mb-md-5">
          <div className="col-md-2">
            <img
              src={ImgProfileNewbieOver}
              alt="Profil débutant"
              className="d-block mx-auto w-100 mb-3"
            />
            <h2 style={{ fontSize: "1rem", fontWeight: "bold" }}>
              Triathlon court ou en relais&nbsp;?
            </h2>
          </div>
          <div className="col-md-6 mb-3 pr-5">
            Débuter en triathlon n'est pas insurmontable ! Il y a certes trois
            disciplines à préparer pour les enchaîner le jour de l'épreuve. Mais
            comme on enchaîne la natation avec le vélo, puis la course à pied,
            il s'agit d'avancer étape par étape. D'autant que le circuit
            national offre un éventail d'épreuves et d'options permettant de
            tester progressivement les sports enchaînés.
          </div>
          {/* header right part */}
          <div className="col-md-4 px-1 sticky-top">
            <div className="sticky-top">
              <p className="font-weight-bold">
                Bien choisir sa distance en triathlon
              </p>
              <div className="row minsize  border border-1 ">
                <div className="col-3 font-weight-bold">Épreuves</div>
                <div className="col-3 font-weight-bold">Natation</div>
                <div className="col-3 font-weight-bold">Vélo</div>
                <div className="col-3 font-weight-bold">Course à pied</div>
              </div>
              {checkboxesFormat.map((item) => (
                <div className="row minsize border-bottom">
                  <div className="col-3 font-weight-bold">{item.value}</div>
                  <div className="col-3">{item.swim}</div>
                  <div className="col-3">{item.bike}</div>
                  <div className="col-3">{item.run}</div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
      {/* page left part*/}
      <div className="row my-2">
        <div className="col-md-8">
          <div className="row mb-4">
            <div className="col-md-4">
              <h5 className="text-warning">
                Des épreuves courtes pour commencer
              </h5>
              <p>
                Le format découverte ou XS (400 m en natation en piscine ou en
                eau libre, une dizaine de kilomètres à vélo et 2,5 km de course
                à pied) permet de se lancer pour appréhender le triathlon. Le
                choix de l'environnement en natation en piscine, cours d'eau,
                mer, un parcours plat, valonné, nature ou urbain en vélo ou en
                course à pied seront également des critères de motivation ou
                propre à rassurer (voir aussi les milieux adaptés aux phobies).
              </p>
            </div>
            <div className="col-md-8">
              <h3 className="font-weight-bold">
                Choisir une épreuve découverte (XS) près de chez vous{" "}
                <span className="text-primary">sans relais</span>
              </h3>
              <ContainerEventsQuery
                region={region.value}
                remove={false}
                format={["XS"]}
                relay={"0"}
                Elevation_bike={0}
                Elevation_run={0}
                bibs={25000}
                Swimenv={[
                  "Piscine",
                  "Lac",
                  "Mer",
                  "Rivière",
                  "Plan d'eau",
                  "0",
                ]}
                crosstri={["1", "0"]}
              />
            </div>
          </div>
          <div className="row">
            <div className="col-md-4">
              <h5 className="text-warning">
                Jouer le triathlon en relais avec chacun sa partie
              </h5>
              <p>
                De multiples formes de pratique se sont développées ces
                dernières années : triathlon en relais (avec une équipe de 2 ou
                3 participants qui se partagent les trois disciplines), le
                triathlon par équipe (toute l'équipe réalise ensemble les trois
                sports), ou le défi de participer à plusieurs triathlons sur un
                même week-end... Autant de moyens de découvrir le triathlon de
                façon ludique, de l'intérieur avec ses règles et l'émulation du
                groupe.
              </p>
            </div>
            <div className="col-md-8">
              <h3 className="font-weight-bold">
                <Group className="mr-1" />
                Tester un triathlon XS{" "}
                <span className="text-primary">en relais</span> près de chez
                vous
              </h3>
              <img src={triDiscover} alt="photo de triathlon Goran Bogicevic" />
              <ContainerEventsQuery
                region={region.value}
                remove={false}
                format={["XS"]}
                relay={"1"}
                Elevation_bike={0}
                Elevation_run={0}
                bibs={25000}
                Swimenv={[
                  "Piscine",
                  "Lac",
                  "Mer",
                  "Rivière",
                  "Plan d'eau",
                  "0",
                ]}
                crosstri={["1", "0"]}
              />
            </div>
          </div>
        </div>
        {/* page right part*/}
        <div className="col-md-4">
          <div className="container">
            <div className="row my-3">
              <div>
                <h4 className="text-center">Choisir votre région</h4>
                <Select
                  defaultValue="Ile-de-France"
                  onChange={handleRegion}
                  menuPortalTarget={document.body}
                  styles={{
                    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                  }}
                  options={Regions}
                  value={region}
                  placeholder="Votre région"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
